/**
 * Safari Autoplay Fix for Shopify Horizon Theme Hero/Background Videos
 * -----------------------------------------------------------------
 * Issue: Horizon's video-background-component sets the <video> element's
 * "src" via JavaScript and calls .load() after the page has loaded.
 * Chrome still honors the declarative "autoplay" attribute afterward, but
 * Safari (WebKit) does not - it silently blocks playback with a
 * NotAllowedError, even though the video is muted + playsinline +
 * autoplay. There's also no built-in fallback in the theme to retry
 * playback, so the video just sits paused indefinitely on Safari.
 *
 * Fix: explicitly call video.play() once each video is ready to play,
 * and as a safety net, retry play() on the visitor's very next click or
 * tap anywhere on the page if the first attempt is rejected. A real user
 * gesture reliably satisfies Safari's autoplay policy.
 *
 * Install (Shopify admin -> Online Store -> Themes -> Edit code):
 *   1. Under "Assets", click "Add a new asset" -> "Create a blank file",
 *      name it exactly: safari-video-autoplay-fix.js
 *      Paste this entire file's contents in and Save.
 *   2. Open "layout/theme.liquid". Just before the closing </body> tag,
 *      add this line and Save:
 *      <script src="{{ 'safari-video-autoplay-fix.js' | asset_url }}" defer></script>
 *   3. Reload memorymount.com in Safari (hard refresh: Cmd+Shift+R) and
 *      confirm the hero video now autoplays.
 */
(function () {
  function attemptPlay(video) {
    if (!video || !video.paused) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Safari refused the initial attempt; wait for a genuine user
        // gesture and retry once. Real clicks/taps satisfy Safari's
        // autoplay policy even when a scripted call doesn't.
        var retry = function () {
          video.play().catch(function () {
            // Still blocked (e.g. autoplay permission fully denied for
            // this site) - leave the video paused on its poster frame.
          });
          document.removeEventListener('click', retry, true);
          document.removeEventListener('touchstart', retry, true);
        };
        document.addEventListener('click', retry, true);
        document.addEventListener('touchstart', retry, true);
      });
    }
  }

  function handleVideo(video) {
    if (video.readyState >= 2) {
      attemptPlay(video);
    } else {
      video.addEventListener('loadedmetadata', function () { attemptPlay(video); }, { once: false });
      video.addEventListener('canplay', function () { attemptPlay(video); }, { once: false });
    }
  }

  function init() {
    document
      .querySelectorAll('video-background-component video, video[autoplay]')
      .forEach(handleVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch videos that get inserted later (theme editor re-renders,
  // Shopify's dynamic/lazy section loading, etc.).
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('video-background-component video, video[autoplay]')) {
          handleVideo(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('video-background-component video, video[autoplay]').forEach(handleVideo);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
